/* Home — The app: pinned phone, 4 screens change on scroll, phone scales to fit the viewport. */
(function () {
  var TYPE = 'home-app';

  function init(root) {
    if (!root || root._ha) return;
    root._ha = true;
    var D = window.Dozzee || {};
    var q = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var one = function (s) { return root.querySelector(s); };

    /* phone scales to fit (also without GSAP / with reduced motion) */
    var fit = one('[data-phone-fit]'), stick = one('[data-app-sticky]');
    var doFit = function () {
      if (!fit || !stick) return;
      fit.style.transform = 'none'; fit.style.marginBottom = '0px';
      var sr = stick.getBoundingClientRect(), cr = fit.getBoundingClientRect();
      var stacked = cr.top - sr.top > 260;
      var avail = D.reduce ? Math.max(window.innerHeight - 150, 300) : (stacked ? sr.bottom - cr.top - 16 : sr.height - 150);
      var s = Math.max(0.3, Math.min(1, avail / 620));
      fit.style.transform = 'scale(' + s.toFixed(3) + ')';
      fit.style.marginBottom = Math.round(620 * (s - 1)) + 'px';
    };
    doFit();
    window.addEventListener('resize', doFit);
    root._haOff = function () { window.removeEventListener('resize', doFit); };

    if (!D.gsap || D.reduce) return;
    D.gsap(function (gsap) {
      if (!root.isConnected) return;
      var dir = D.settings && D.settings.rtl ? -1 : 1;
      doFit();
      root._ctx = gsap.context(function () {
        var scr = q('[data-scr]'), ft = q('[data-ft]'), seg = q('[data-aseg]'), ind = one('[data-tab-ind]'), ph = one('[data-phone]');
        scr.concat(ft).forEach(function (e) { e.classList.remove('is-off'); });
        gsap.set(scr.slice(1).concat(ft.slice(1)), { autoAlpha: 0 });
        var ta = gsap.timeline({ scrollTrigger: { trigger: root, start: 'top top', end: 'bottom bottom', scrub: 0.6 } });
        seg.forEach(function (s, i) { ta.fromTo(s, { scaleX: 0 }, { scaleX: 1, ease: 'none', duration: 1 }, i); });
        for (var i = 1; i < scr.length; i++) {
          ta.to(scr[i - 1], { autoAlpha: 0, x: -24 * dir, duration: 0.25, ease: 'power1.in' }, i - 0.12)
            .fromTo(scr[i], { autoAlpha: 0, x: 30 * dir }, { autoAlpha: 1, x: 0, duration: 0.3, ease: 'power2.out' }, i);
          if (ft[i]) ta.to(ft[i - 1], { autoAlpha: 0, y: -14, duration: 0.18 }, i - 0.12)
            .fromTo(ft[i], { autoAlpha: 0, y: 14 }, { autoAlpha: 1, y: 0, duration: 0.24 }, i + 0.02);
          if (ind) ta.to(ind, { xPercent: 100 * i * dir, duration: 0.3, ease: 'power2.inOut' }, i - 0.1);
        }
        if (ph) ta.fromTo(ph, { rotation: -3 }, { rotation: 3, ease: 'none', duration: scr.length }, 0);
        var knobProp = dir < 0 ? 'right' : 'left', kFrom = {}, kTo = { duration: 0.3, ease: 'power2.out' };
        kFrom[knobProp] = '100%'; kTo[knobProp] = '60%';
        ta.fromTo(one('[data-np-bar]'), { scaleX: 0.12 }, { scaleX: 0.7, ease: 'none', duration: 0.85 }, 1.05)
          .fromTo(one('[data-vol-fill]'), { scaleX: 1 }, { scaleX: 0.6, duration: 0.3, ease: 'power2.out' }, 2.1)
          .fromTo(one('[data-vol-knob]'), kFrom, kTo, 2.1);
        q('[data-tg]').forEach(function (t, k) {
          ta.fromTo(t, { backgroundColor: '#D6CFBE' }, { backgroundColor: '#4B5A3C', duration: 0.1 }, 2.3 + k * 0.12)
            .fromTo(t.firstElementChild, { x: 0 }, { x: 18 * dir, duration: 0.1 }, 2.3 + k * 0.12);
        });
        ta.from(q('[data-fam]'), { autoAlpha: 0, y: 20, stagger: 0.08, duration: 0.2 }, 3.08).to({}, { duration: 0.35 });
        gsap.from(one('[data-phone-in]'), { y: 160, autoAlpha: 0, ease: 'power3.out', scrollTrigger: { trigger: root, start: 'top 85%', end: 'top 15%', scrub: 0.7 } });
      }, root);
    });
  }

  function all(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-section-type="' + TYPE + '"]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-section-type="' + TYPE + '"]'), function (r) {
      if (r._haOff) r._haOff();
      if (r._ctx) r._ctx.revert();
    });
  });
})();
